"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTokenWithGraphApi = void 0;
const axios_1 = require("axios");
const axios_try_catch_wrapper_1 = require("./axios-try-catch-wrapper");
const callGraphApi = async (accessToken) => axios_1.default.get('https://graph.microsoft.com/v1.0/me', {
    headers: { authorization: `Bearer ${accessToken}` },
});
const validateTokenWithGraphApi = async (accessToken, tokenPayload) => {
    if (!tokenPayload.oid) {
        throw new Error(`The token's payload does not contain "oid" property`);
    }
    const response = await axios_try_catch_wrapper_1.axiosTryCatchWrapper(() => callGraphApi(accessToken), 'Graph API tells your token is invalid');
    const isSameId = response.data.id === tokenPayload.oid;
    if (!isSameId) {
        throw new Error('The token`s payload "oid" value does not match with "id" one from graph API');
    }
};
exports.validateTokenWithGraphApi = validateTokenWithGraphApi;
